<template>
  <div class="pb-3">
    <div class="px-7 max-w-xl mx-auto">
      <div
        v-if="errorMessage"
        class="text-xs my-2 text-center ion-text-red"
        v-html="errorMessage"
      ></div>
      <button
        expand="block"
        color="secondary"
        class="button-purple mb-6"
        :disabled="mfaSaving || !mfaOptionSelected"
        :id="optionUnenrol ? 'open-modal-mfa-disable-confirm' : ''"
        @click="optionUnenrol ? openModal() : saveSettings()"
      >
        <div class="flex items-center justify-center">
          <ion-spinner
            name="crescent"
            class="m-2"
            v-if="mfaSaving"
          ></ion-spinner>
          <span class="font-bold text-[14px] capitalize block text-white">
            {{ btnLabel }}
          </span>
        </div>
      </button>

      <ion-modal
        class="modal-center"
        ref="modal-mfa-disable-confirm"
        trigger="open-modal-mfa-disable-confirm"
        backdrop-dismiss="false"
        :isOpen="modalMfaDisableConfirmOpen"
        v-if="optionUnenrol"
      >
        <ion-card class="bg-white m-0 p-0 rounded-xl">
          <ion-card-content class="p-4">
            <ion-grid>
              <ion-row>
                <ion-col class="py-3">
                  <ion-text class="text-lg font-bold ion-text-brand capitalize"
                    >Are you sure?</ion-text
                  >
                  <ion-text class="text-sm ion-text-purple block my-3 mr-8">
                    You are about to disable MFA for your account. Please
                    confirm to proceed.
                  </ion-text>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <button class="button-purple" @click="saveSettings">
                    <span class="ion-text-white font-bold">Confirm</span>
                  </button>
                  <button
                    fill="outline"
                    class="button-outline button-outline-purple mt-4"
                    @click="closeModal"
                  >
                    <span class="font-bold">Cancel</span>
                  </button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-modal>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from "vue";
import router from "@/router";
import { useCustomerStore } from "@/stores";
import { storeToRefs } from "pinia";
import { useBrowser } from "@/composables/browser";
import axios from "axios";
import { modalController } from "@ionic/vue";
import { useSecureStorage } from "@/composables/secureStorage";
const customerStore = useCustomerStore();
const {
  deviceID,
  environment,
  authToken,
  mfaSaving,
  mfaOptionSelected,
  mfaLoginType,
} = storeToRefs(customerStore);
const {
  setMfaLoginType,
  setMfaOptionSelected,
  setMfaSaving,
  setMfaEnrolMsg,
  setMfaEnrolType,
  setMfaEnrolContact,
  setMfaUpdatedMsg,
  setMfaEnabled,
} = customerStore;
const { keys, setStorage } = useSecureStorage();
const { urls } = useBrowser();
const errorMessage = ref("");
const init = () => {
  setMfaSaving(false);
  setMfaEnrolMsg(null);
  setMfaEnrolType(null);
  setMfaEnrolContact(null);
  errorMessage.value = "";
  modalMfaDisableConfirmOpen.value = false;
};
const btnLabel = computed(() => {
  if (errorMessage.value) {
    return "Try Again";
  } else {
    if (!mfaOptionSelected.value) {
      return "Please Select MFA Method";
    } else {
      return `${optionUpdated.value ? "Setup" : "Disable"} MFA`;
    }
  }
});
const optionUpdated = computed(
  () =>
    mfaOptionSelected.value !== null &&
    mfaOptionSelected.value !== mfaLoginType.value
);
const optionUnenrol = computed(
  () =>
    mfaOptionSelected.value !== null &&
    mfaOptionSelected.value == mfaLoginType.value
);
const modalMfaDisableConfirmOpen = ref(false);
const headers = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + authToken.value,
  },
};
const payload = computed(() => ({
  device_id: deviceID.value,
  mfa_type: mfaOptionSelected.value,
  environment: environment.value,
  ...(optionUnenrol.value && { confirm: true }),
}));
const saveSettings = () => {
  setMfaSaving(true);
  axios
    .post(
      optionUnenrol.value ? urls.apiMfaUnenrol : urls.apiMfaEnrol,
      payload.value,
      headers
    )
    .then((response) => {
      if (response.status == 200) {
        setMfaSaving(false);
        if (optionUnenrol.value) {
          closeModal();
          setMfaEnabled(false);
          setMfaLoginType(null);
          setMfaOptionSelected(null);
          setMfaUpdatedMsg(response.data.message);
          setTimeout(() => {
            setMfaUpdatedMsg("");
          }, 5000);
          setStorage({
            key: keys.mfa,
            value: JSON.stringify({
              required: false,
              type: null,
              contact: null,
              enabled: false,
            }),
          });
        }
        if (optionUpdated.value) {
          setMfaEnrolMsg(response.data.message);
          setMfaEnrolType(response.data.method_type);
          setMfaEnrolContact(response.data.contact_point);
          router.push({
            name: "MfaVerify",
          });
        }
      }
    })
    .catch((error) => {
      if (error) {
        closeModal();
        errorMessage.value =
          "There was an error processing your request. Please try again later.";
      }
    });
};
const openModal = () => {
  modalMfaDisableConfirmOpen.value = true;
};
const closeModal = () => {
  modalController.dismiss();
  modalMfaDisableConfirmOpen.value = false;
};
onMounted(() => {
  init();
  setMfaUpdatedMsg("");
});
watch(
  btnLabel,
  () => {
    init();
  },
  { immediate: true }
);
</script>
